import React from "react";
import { Container } from "@pixi/react";
import { useSelector } from "react-redux";
import JackpotDisplay from "../JackpotDisplay/JackpotDisplay";
const Jackpots = ({ symbolSize, y, zIndex, dimensions }) => {
  const { jackpots, isLoading } = useSelector((state) => state.game);

  if (isLoading) return null;

  return (
    <Container
      name="Jackpots"
      y={y - symbolSize / 10}
      zIndex={zIndex}
      sortableChildren
      x={0}
    >
      <JackpotDisplay
        dimensions={dimensions}
        width={symbolSize}
        height={symbolSize / 2}
        x={0}
        y={0}
        value={jackpots[0]?.value}
        name={jackpots[0]?.name}
        zIndex={2}
      />

      <JackpotDisplay
        dimensions={dimensions}
        width={symbolSize}
        height={symbolSize / 2}
        x={-(symbolSize * 1.75)}
        y={0}
        value={jackpots[1]?.value}
        name={jackpots[1]?.name}
        zIndex={2}
      />

      <JackpotDisplay
        dimensions={dimensions}
        width={symbolSize}
        height={symbolSize / 2}
        x={symbolSize * 1.75}
        y={0}
        value={jackpots[2]?.value}
        name={jackpots[2]?.name}
        zIndex={2}
      />
    </Container>
  );
};
export default Jackpots;
